import { render, staticRenderFns } from "./PieceTitle.vue?vue&type=template&id=5a767ce8&scoped=true&"
import script from "./PieceTitle.vue?vue&type=script&lang=js&"
export * from "./PieceTitle.vue?vue&type=script&lang=js&"
import style0 from "./PieceTitle.vue?vue&type=style&index=0&id=5a767ce8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a767ce8",
  null
  
)

export default component.exports